import { Component } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, Permission, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { HrmDiskFormat } from "../../../models/base-info/hrm-disk-format.model";
import { HrmDiskFormatExportComponent } from "../hrm-disk-format-export/hrm-disk-format-export.component";
import { HrmDiskFormatFormComponent } from "../hrm-disk-format-form/hrm-disk-format-form.component";
import { HrmDiskItemFormatFormComponent } from "../hrm-disk-item-format/hrm-disk-item-format.component";

@Component({
  selector: "ngx-hrm-disk-format-list",
  templateUrl: "./hrm-disk-format-list.component.html",
  styleUrls: ["./hrm-disk-format-list.component.scss"],
})
export class HrmDiskFormatListComponent extends BaseListComponent {
  actions: EntityListAction[];
  loadingIndicator: boolean;
  inputEditorform: any;
  model: any;
  pcInsColumns: form_control[] = [];
  pcTaxColumns: form_control[] = [];
  editingName: { name: string };
  constructor() {
    super();
    this.onActionClick = this.onActionClick.bind(this);
    this.inputEditorform = HrmDiskFormatFormComponent;
  }
  ngOnInit() {
    this.apiName = "HrmDiskFormat";
    this.areaName = "Payroll";
    this.label = "فهرست قالب دیسکت";
    this.setactions();
    this.setColumns();
  }
  setColumns() {
    let group: any = {};
    this.model = {};
    this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueYear",
      disabled: false,
      name: "IssueYear",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 1,
      userClass: "select-sm",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.columns.push(<form_control>{
      label: "ماه",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueMonth",
      disabled: false,
      name: "IssueMonth",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 2,
      userClass: "select-sm",
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });

    group["IssueYear"] = new UntypedFormControl(this.model.IssueYear, Validators.required);
    group["IssueMonth"] = new UntypedFormControl(this.model.IssueMonth, Validators.required);

    this.group = new UntypedFormGroup(group);
    this.model = this.getDataFromFormGroup(this.model);
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: HrmDiskFormat,
    onRowsSelected: HrmDiskFormat[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (action.name === "HrmDiskFormatExport") {
      let IssueYear = this.group.controls["IssueYear"].value;
      let IssueMonth = this.group.controls["IssueMonth"].value;
      if (!IssueYear || !IssueMonth) {
        this.sts.showDialog("اول سال و ماه مورد نظر را انتخاب كنيد.", "خطا");
        return;
      }
      this.dialogService
        .open(
          action.Form_Component,
          {
            IssueYear: IssueYear,
            IssueMonth: IssueMonth,
            currentrow: onRowSelected,
            apiName: action.apiName,
            isModal: action.isModal,
            areaName: action.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {});
    }
    if (action.name === "HrmDiskItemFormat") {
      this.dialogService
        .open(
          action.Form_Component,
          {
            currentrow: onRowSelected,
            apiName: action.apiName,
            isModal: action.isModal,
            areaName: action.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {});
    }
  }
  setactions() {
    this.actions = [
      {
        name: "HrmDiskItemFormat",
        disabled: true,
        displayName: "قالب فایل خروجی",
        iconName: "icon-floppy-o",
        apiName: "HrmDiskFormat/HrmDiskItemFormat",
        areaName: "Payroll",
        requireSelectedrows: true,
        Form_Component: HrmDiskItemFormatFormComponent,
        permission: Permission.samePermission,
      },
      {
        name: "HrmDiskFormatExport",
        disabled: false,
        displayName: "ساخت فایل خروجی",
        iconName: "icon-floppy-o",
        apiName: "HrmDiskFormat/HrmDiskFormatExport",
        areaName: "Payroll",
        requireSelectedrows: true,
        Form_Component: HrmDiskFormatExportComponent,
        permission: Permission.samePermission,
      },
    ];
  }
}
